import Vue from "vue";

const notifyError = error => {
  Vue.$notification.error(error.message, { offset: 120 });
  throw error;
};

export default {
  getTrainings({ commit, state }, filters = {}) {
    commit("tableLoading", true);
    return Vue.$http
      .get("/hrm/trainings", {
        params: {
          page: state.currentPage,
          perPage: state.perPage,
          ...(state.searchQuery && { search_query: state.searchQuery }),
          ...filters,
        },
      })
      .then(response => {
        commit("trainings", response.data.results || []);
        commit("total", response.data.total || 0);
        return response.data;
      })
      .catch(notifyError)
      .finally(() => commit("tableLoading", false));
  },
  getTraining({ commit }, id) {
    commit("tableLoading", true);
    return Vue.$http
      .get(`/hrm/trainings/${id}`)
      .then(response => {
        commit("currentTraining", response.data);
        return response.data;
      })
      .catch(notifyError)
      .finally(() => commit("tableLoading", false));
  },
  createTraining({ commit }, payload) {
    commit("tableLoading", true);
    return Vue.$http
      .post("/hrm/trainings", payload)
      .then(response => {
        Vue.$notification.success(response.message);
        return response.data;
      })
      .catch(notifyError)
      .finally(() => commit("tableLoading", false));
  },
  updateTraining({ commit }, payload) {
    commit("tableLoading", true);
    return Vue.$http
      .put(`/hrm/trainings/${payload.id}`, payload)
      .then(response => {
        Vue.$notification.success(response.message);
        return response.data;
      })
      .catch(notifyError)
      .finally(() => commit("tableLoading", false));
  },
  deleteTraining({ dispatch }, { id, filters = {} }) {
    return Vue.$http
      .delete(`/hrm/trainings/${id}`)
      .then(response => {
        Vue.$notification.success(response.message);
        return dispatch("getTrainings", filters);
      })
      .catch(notifyError);
  },
  approveTraining({ dispatch }, { id, status, filters = {} }) {
    return Vue.$http
      .patch(`/hrm/trainings/${id}/approval`, { status })
      .then(response => {
        Vue.$notification.success(response.message);
        return dispatch("getTrainings", filters);
      })
      .catch(notifyError);
  },
  handleSizeChange({ commit, dispatch }, { perPage, filters = {} }) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    return dispatch("getTrainings", filters);
  },
  handleCurrentChange({ commit, dispatch }, { page, filters = {} }) {
    commit("currentPage", page);
    return dispatch("getTrainings", filters);
  },
};
